var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit-project",
            "ok-only": "",
            "ok-title": "Edit",
            centered: "",
            size: "lg",
            title: "Edit Project",
            "hide-footer": true,
          },
        },
        [
          _c("Editproject", {
            attrs: {
              project: _vm.currentProject,
              assignee: _vm.assignee_options,
            },
            on: { projectAdded: _vm.closeEditProjectModal },
          }),
        ],
        1
      ),
      _vm.loading
        ? _c("b-card", [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  staticStyle: { width: "3rem", height: "3rem" },
                  attrs: { variant: "success", label: "Spinning" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      !_vm.loading
        ? _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Project Name",
                                    "label-for": "project-name",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "project-name",
                                      placeholder: "No Name",
                                      required: "",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "name", $$v)
                                      },
                                      expression: "project.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Approver",
                                    "label-for": "project_manager",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getApproverName(
                                          _vm.project.approverId
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Customer",
                                    "label-for": "customer",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getCustomerName(
                                          _vm.project.customerId
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Project Status",
                                    "label-for": "project-status",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "project-status",
                                      placeholder: "No Status",
                                      required: "",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "status", $$v)
                                      },
                                      expression: "project.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Progress",
                                    "label-for": "Progress",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "Progress",
                                      placeholder: "No Progress",
                                      required: "",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.progress,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "progress", $$v)
                                      },
                                      expression: "project.progress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Priority",
                                    "label-for": "Priority",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "Priority",
                                      placeholder: "No Priority",
                                      required: "",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.priority,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "priority", $$v)
                                      },
                                      expression: "project.priority",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Start Date",
                                    "label-for": "Start-Date",
                                  },
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-1",
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.project.startDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "startDate", $$v)
                                      },
                                      expression: "project.startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "End Date",
                                    "label-for": "End-Date",
                                  },
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-1",
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.project.endDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "endDate", $$v)
                                      },
                                      expression: "project.endDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Description",
                                    "label-for": "description",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "description",
                                      placeholder: "Description of project ",
                                      rows: "1",
                                      required: "",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.project,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "project.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Budget",
                                    "label-for": "budget",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "budget",
                                      type: "number",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.budget,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "budget", $$v)
                                      },
                                      expression: "project.budget",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Expense",
                                    "label-for": "expense",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "expense",
                                      type: "number",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.expense,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "expense", $$v)
                                      },
                                      expression: "project.expense",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Estimates",
                                    "label-for": "estimates",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "estimates",
                                      type: "number",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.project.estimates,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.project, "estimates", $$v)
                                      },
                                      expression: "project.estimates",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end",
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.modal-edit-project",
                                      modifiers: { "modal-edit-project": true },
                                    },
                                  ],
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editProject(_vm.project)
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.project.status !== "REMOVED"
        ? _c(
            "b-card",
            [
              _c("h3", [_vm._v("Milestones")]),
              _c(
                "b-card-body",
                [
                  _c("MilestonesList", {
                    attrs: { projectId: this.id },
                    on: { updateMilestoneCount: _vm.handleMilestoneCount },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.project.status !== "REMOVED"
        ? _c(
            "b-card",
            [
              _c("h3", [_vm._v("Tasks")]),
              _c(
                "b-card-body",
                [
                  _c("TaskList", {
                    attrs: { projectId: this.id },
                    on: { updateTasksCount: _vm.handleTaskCount },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.project.status !== "REMOVED"
        ? _c("b-card", [_c("b-card-body", [_c("CostListPerProject")], 1)], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }